import { useEffect } from 'react';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { reportScreen } from '../../services/analyticsService';
import { Page } from '../../components/layout';
import ContentHeader from '../../components/ContentHeader';
import { TopAssetManagersReport } from './Components/TopAssetManagersReport';

export default () => {
  useDocumentTitle('Top Asset Managers Report');
  useEffect(() => {
    reportScreen('top asset managers report');
  }, []);

  return (
    <Page>
      <ContentHeader title="Asset Managers Tracker" />
      <TopAssetManagersReport />
    </Page>
  );
};
